import { CheckCircleFilled, ExclamationCircleFilled, InfoCircleFilled, WarningFilled } from "@ant-design/icons";
import ColorRate from "../../../../common/utils/ColorRate";


export const ActionAlert = (props : {severity: string, description: string, color?: string}) => {

  const SEVERITY: any = {
    'success' : { color: 'green', icon: <CheckCircleFilled style={{fontSize: '17px'}}/> },
    'warning': { color: 'darkorange', icon: <WarningFilled style={{fontSize: '17px'}}/> },
    'critical': { color: 'crimson', icon: <ExclamationCircleFilled style={{fontSize: '17px'}}/> },
    'info': { color: 'dodgerblue', icon: <InfoCircleFilled style={{fontSize: '17px'}}/> }
  };

  return (
    <>      
        <div style={{color:props.color ? props.color : SEVERITY[props.severity].color}}>
        {SEVERITY[props.severity].icon} <span style={{color:props.color ? props.color : SEVERITY[props.severity].color}}> {props.description}</span>
        </div>          
    </>    
  )
};
